<template>
    <div>
        <hr class="kgr-separator" />
        <h2 class="kgr-headline kgr-headline--h2 kgr-headline--text">
            {{ result.description }}
        </h2>

        <div class="kgr-inputGroup">
            <kgr-form-row
                :label="$t('Anmerkung')"
                :error="error"
                field-name="note"
            >
                <textarea
                    v-model.trim="result.note"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                ></textarea>
            </kgr-form-row>
            <kgr-form-row
                :label="$t('club.exam.result.status')"
                :error="error"
                field-name="status"
            >
                <kgr-generic-radio
                    v-model="result.status"
                    :name="`resultStatus_${result.id}`"
                    :options="statusOptions"
                />
            </kgr-form-row>
        </div>
    </div>
</template>

<script>
import Error from '../../js/model/Error.js';
import ExamPartResult from '../../js/dto/club/ExamPartResult.js';
import FormRow from '../common/form/FormRow.vue';
import GenericRadio from '../common/form/radio/GenericRadio.vue';

export default {
    components: {
        'kgr-generic-radio': GenericRadio,
        'kgr-form-row': FormRow,
    },
    props: {
        examPartResult: {
            type: ExamPartResult,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            result: this.examPartResult,
            statusOptions: {
                'club.exam.result.status.success': 'success',
                'club.exam.result.status.failure': 'failure',
            },
        };
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
